module.exports = __webpack_public_path__ + "static/media/loader.fea523d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/subscribe/loader.svg
// module id = 1560
// module chunks = 0